"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Skeleton_1 = tslib_1.__importDefault(require("@mui/material/Skeleton"));
const SkeletonInfoText = ({ instances, skeletonProps }) => (react_1.default.createElement(react_1.default.Fragment, null, Array(instances)
    .fill(instances)
    .map((item, index) => (
// Wrapping in Typography to match the size of a InfoCardSubject that contains actual information
react_1.default.createElement(material_1.Typography, { key: index },
    react_1.default.createElement(Skeleton_1.default, { ...skeletonProps }))))));
// A skeleton component to render instead of an info card with actual information
const InfoCardSubjectSkeleton = (props) => {
    const { animation, variant } = props;
    return (react_1.default.createElement(Grid_1.default, { sx: { width: (theme) => theme.spacing(30) } },
        react_1.default.createElement(SkeletonInfoText, { instances: 3, skeletonProps: { variant: variant, animation: animation } })));
};
exports.default = InfoCardSubjectSkeleton;
